<script>
import Multiselect from 'vue-multiselect';

export default {
    mixins: [Multiselect],
    props: {
        selectLabel: { type: String, default: '' },
        selectGroupLabel: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        deselectLabel: { type: String, default: '' },
        selectedLabel: { type: String, default: 'Valgt' },
    },
};
</script>
